"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Offerwall = void 0;
const util_1 = require("@app/util");
const CLICK_TRACKED_ATTR = 'data-bi-click-tracked';
class Offerwall {
    constructor(loc, linksSelector, session) {
        this.loc = loc;
        this.linksSelector = linksSelector;
        this.session = session;
        this.clicksEvents = [];
        this.session.initParams();
    }
    // replace placeholders
    trackLinks() {
        const PP_WEBID = 'webid'; // webmasters id from partners network
        const params = {
            loc: this.loc,
            shortId: this.session.getShortId(),
            ...this.session.getUtm(),
        };
        params[PP_WEBID] = this.session.getParntersWebId();
        const trackLinks = document.querySelectorAll(this.linksSelector + '[href]');
        trackLinks.forEach((a) => {
            a.href = (0, util_1.replaceUrlPlaceholders)(a.href, params);
        });
    }
    addClickEvent(callback) {
        this.clicksEvents.push(callback);
    }
    trackClicks() {
        const self = this;
        document.querySelectorAll(this.linksSelector + '[href]').forEach((a) => {
            // skip links that already have a click listener from a previous doit()/trackClicks()
            if (a.hasAttribute(CLICK_TRACKED_ATTR)) {
                return;
            }
            a.setAttribute(CLICK_TRACKED_ATTR, '1');
            a.addEventListener('click', function () {
                self.clicksEvents.forEach(cb => {
                    try {
                        cb(a);
                    }
                    catch (e) {
                        console.warn('callback click error', e);
                    }
                });
            });
        });
    }
}
exports.Offerwall = Offerwall;
